<template lang="pug">
.modelos-tecnicos-container
  modal-mod-tec(
    :openModal="modal",
    @close="closeModal",
    :edicao="modelosEdicao",
    @atualiza="atualizaLista"
  )
  .modelos-conteudo
    .filtro
      .busca
        el-input(
          placeholder="Buscar...",
          prefix-icon="fa fa-search",
          v-debounce:500ms="buscaPorNome",
          v-model="busca"
        )
    .sem-cadastro(v-if="!this.modelos.length") Nenhum modelo técnico cadastrado!
    ul.corpo-lista(v-else)
      li.lista(
        @click="abreModalEditar(list)",
        v-for="(list, a) in modelos",
        :key="a",
        :class="[list.status === 'I' ? 'inativo' : '']"
      )
        .icn
          img(
            v-if="list.status === 'A'",
            src="../../assets/modelos-tecnicos.svg"
          )
          img(v-else, src="../../assets/modelos-tecnicos-inativos.svg")
        .info
          .nome-modelo {{ list.nome }}
          .dados-modelo(v-html="list.modelo")
        .acao
          i.fa.fa-pencil(aria-hidden="true")

    .paginacao(v-if="qtdModelo > 10")
      el-pagination(
        layout="prev, pager, next",
        prev-text="Anterior",
        next-text="Próximo",
        :total="Number(qtdModelo)",
        @current-change="handleCurrentChange"
      )
</template>

<script>
import ModalModTec from "./ModalModTec";
import Services from "../../utils/services";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
moment.locale("pt-BR");

export default {
  components: { ModalModTec },

  created() {
    this.getModelos();
  },

  data: () => ({
    modal: false,
    busca: "",
    modelos: [],
    qtdModelo: null,
    page: 0,
    size: 10,
    modelosEdicao: "",
  }),

  computed: {
    ...mapGetters(["getModal"]),
  },

  watch: {
    getModal() {
      if (this.getModal === "Modelos") this.abreModalCadastrar();
    },
  },

  methods: {
    ...mapMutations(["setLoad", "setModal"]),

    /* Método que lista os modelos */
    async getModelos() {
      this.setLoad(true);
      let auxListModelos = await Services.get(
        `/modelo-tecnico/listar/${this.size}/pular/${this.page * 10}`
      );
      console.log(auxListModelos);
      this.modelos = auxListModelos.lista;
      if (this.modelos) {
        this.setLoad(false);
        this.qtdModelo = auxListModelos.quantidade[0].quantidade;
      }
    },

    async buscaPorNome() {
      this.setLoad(true);
      if (this.busca) {
        this.modelos = await Services.get(`/modelo-tecnico/${this.busca}`);
        if (this.modelos) {
          this.setLoad(false);
          this.qtdModelo = null;
          this.page = 0;
        }
      } else this.getModelos();
    },

    /* Metodo que abre o modal de um novo cadastro */
    abreModalCadastrar() {
      this.modal = true;
    },

    /* Metodo que abre o modal de edição */
    abreModalEditar(list) {
      this.modal = true;
      this.modelosEdicao = list;
    },

    /* Metodo que atualiza a lista de pacientes quando houver sucesso no cadastro ou edicao */
    atualizaLista() {
      this.getModelos();
    },

    /* Metodo que fecha o modal */
    closeModal() {
      this.modal = false;
      this.setModal("");
      this.modelosEdicao = "";
    },

    /* Metodo referente a paginacao */
    handleCurrentChange(val) {
      this.page = val - 1;
      this.getModelos();
    },
  },
};
</script>

<style lang="scss">
.modelos-tecnicos-container {
  width: 1100px;
  height: calc(100% - 120px);
  margin: 0 auto;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .modelos-conteudo {
    .filtro {
      margin-top: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .filtros,
      .ordenacao {
        width: 140px;
        height: 55px;

        .el-badge.item {
          width: 100%;
          height: 100%;

          .el-badge__content {
            border-radius: 20px;
            font-size: 16px;
            padding: 3px 8px;
            background-color: #0180ff;

            &.is-fixed {
              right: 30px;
            }
          }
        }

        button {
          width: 100%;
          height: 100%;
          border-radius: 30px;
          font-size: 18px;

          i {
            margin-left: 8px;
            font-size: 20px;
            color: #fbb30b;
          }
        }
      }
      .busca {
        //width: 793px;
        width: 100%;
        height: 55px;

        .el-input {
          height: 100%;

          input {
            height: 100%;
            border-radius: 30px;
            padding-left: 45px;
            font-size: 18px;
          }

          i {
            font-size: 20px;
            color: #fbb30b;
            margin-left: 10px;
          }
        }
      }
    }

    .sem-cadastro {
      margin-top: 100px;
      width: 90%;
      margin: 100px auto;
      height: 200px;
      background: rgb(245, 245, 245, 0.3);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 300;
      color: red;
      box-shadow: 1px 3px 6px rgba(0, 0, 0, 0.3);
    }

    ul.corpo-lista {
      margin: 0;
      padding: 25px 0;
      box-sizing: border-box;

      li.lista {
        width: 100%;
        height: 85px;
        padding: 0 25px;
        margin-bottom: 15px;
        border: 1px solid #cbcbcb;
        border-radius: 10px;
        box-sizing: border-box;
        cursor: pointer;
        list-style: none;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.inativo {
          .info {
            .nome-modelo {
              color: #666;
            }
            .dados-modelo {
              color: #cbcbcb;
            }
          }
        }

        &:last-child {
          margin-bottom: 0;
        }

        .icn {
          margin-right: 25px;
        }

        .info {
          flex: 1;
          display: flex;
          height: 100%;
          flex-direction: column;
          justify-content: center;

          .nome-modelo {
            font-size: 20px;
            color: #0180ff;
            font-weight: 400;
            margin-bottom: 2px;
          }
          .dados-modelo {
            font-size: 16px;
            color: #000;
            font-weight: 100;
            white-space: nowrap;
            width: 601px;
            height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .acao {
          i {
            font-size: 26px;
            transform: rotate(-10deg);
            color: #0180ff;
          }
        }
      }
    }

    .paginacao {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
    }
  }
}
</style>